import { createRequest } from '@shared/services';

interface PostProductSizeValidatePayload extends ProductSizeProperties {}

export async function postProductSizeValidate(
    data: PostProductSizeValidatePayload,
    id?: string
) {
    const request = createRequest<PostProductSizeValidateResponse>({
        url: `/product/size/validate${id ? `/${id}` : ''}`,
        method: 'POST',
        withAuthorization: true,
        useToastHandler: false,
        data,
    });

    return request.execute();
}
